import styled from 'styled-components'

export const IMAGE_ZOOM_FRAME_MARGIN = 10

export const ImageZoomContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  cursor: grab;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ImageZoomController = styled.div`
  position: absolute;
  padding: ${IMAGE_ZOOM_FRAME_MARGIN}px;
  display: flex;
  width: 100% !important;
  justify-content: center;
  align-items: center;
  bottom: 20px;
  gap: 10px;
`

export const Image = styled.img<{ isVisible: boolean }>`
  border-radius: 2px;
  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
`

export const LoaderContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
